import { Api } from "./Api";

const api = new Api()

export function getSecurityQuestions() {
    return api.get('defaults/security_questions')
}
